// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Arya', 'Arya Fallback'","fontStyle":"normal"},"className":"__className_4d5631"};